import { apiFetch, hasSession } from '../auth/account.js';
import { state } from '../core/state.js';
import { $ } from '../core/text.js';
import { setView } from '../ui/views.js';

/* ══════════ Soziale API (Freunde, Community-Decks) ══════════ */
export const cloudSetUsername   = (username) => apiFetch('/profile/username', { method: 'POST', body: JSON.stringify({ username }) });
export const cloudSearchUsers   = (q) => apiFetch('/users/search?q=' + encodeURIComponent(q));
export const cloudFriends       = () => apiFetch('/friends');
export const cloudFriendReq     = (userId) => apiFetch('/friends/request', { method: 'POST', body: JSON.stringify({ userId }) });
export const cloudFriendRespond = (userId, accept) => apiFetch('/friends/respond', { method: 'POST', body: JSON.stringify({ userId, accept }) });
export const cloudFriendRemove  = (userId) => apiFetch('/friends/remove', { method: 'POST', body: JSON.stringify({ userId }) });
export const cloudPublish       = (payload) => apiFetch('/decks/publish', { method: 'POST', body: JSON.stringify(payload) });
export const cloudUnpublish     = (id) => apiFetch('/decks/unpublish', { method: 'POST', body: JSON.stringify({ id }) });
export const cloudMyDecks       = () => apiFetch('/decks/mine');
export const cloudLibrary       = (q, sort, subject) => apiFetch('/decks/library?q=' + encodeURIComponent(q || '') + '&sort=' + (sort || 'likes') + '&subject=' + encodeURIComponent(subject || ''));
export const cloudFriendDecks   = () => apiFetch('/decks/friends');
export const cloudAdvBoard      = (sort) => apiFetch('/adv/leaderboard?sort=' + (sort || 'section'));
export const cloudAdvDuel       = () => apiFetch('/adv/duel');
export const cloudGetDeck       = (id) => apiFetch('/decks/get?id=' + encodeURIComponent(id));
export const cloudLike          = (id) => apiFetch('/decks/like', { method: 'POST', body: JSON.stringify({ id }) });
export const cloudSocial        = () => apiFetch('/me/social');
export const cloudPreview       = (id) => apiFetch('/decks/preview?id=' + encodeURIComponent(id));
export const cloudUpdate        = (payload) => apiFetch('/decks/update', { method: 'POST', body: JSON.stringify(payload) });
export const cloudReview        = (id, stars, comment) => apiFetch('/decks/review', { method: 'POST', body: JSON.stringify({ id, stars, comment }) });
export const cloudReviews       = (id) => apiFetch('/decks/reviews?id=' + encodeURIComponent(id));
export const cloudReport        = (id, reason) => apiFetch('/decks/report', { method: 'POST', body: JSON.stringify({ id, reason }) });
export const cloudCommSearch       = (q) => apiFetch('/communities/search?q=' + encodeURIComponent(q));
export const cloudCommJoin         = (payload) => apiFetch('/communities/join', { method: 'POST', body: JSON.stringify(payload) });
export const cloudCommLeave        = (id) => apiFetch('/communities/leave', { method: 'POST', body: JSON.stringify({ id }) });
export const cloudCommMine         = () => apiFetch('/communities/mine');
export const cloudCommLeaderboard  = (id, sort) => apiFetch('/communities/leaderboard?id=' + encodeURIComponent(id) + '&sort=' + (sort || 'xp'));
export const cloudCommDecks        = (id, q) => apiFetch('/communities/decks?id=' + encodeURIComponent(id) + '&q=' + encodeURIComponent(q || ''));
export const cloudChallenges       = () => apiFetch('/challenges');
export const cloudChallengeCreate  = (opponentId, days) => apiFetch('/challenges/create', { method: 'POST', body: JSON.stringify({ opponentId, days }) });
export const cloudChallengeRespond = (id, accept) => apiFetch('/challenges/respond', { method: 'POST', body: JSON.stringify({ id, accept }) });
export const cloudChallengeCancel  = (id) => apiFetch('/challenges/cancel', { method: 'POST', body: JSON.stringify({ id }) });
export const cloudDeleteAccount    = () => apiFetch('/account/delete', { method: 'POST', body: '{}' });
export const cloudSetReminders     = (on) => apiFetch('/me/reminders', { method: 'POST', body: JSON.stringify({ on: !!on }) });
export const cloudInvite           = () => apiFetch('/invite');
export const cloudInviteClaim      = () => apiFetch('/invite/claim', { method: 'POST', body: '{}' });
export const cloudRedeemInvite     = (code) => apiFetch('/invite/redeem', { method: 'POST', body: JSON.stringify({ code }) });
export const cloudFeed             = () => apiFetch('/feed');
export const cloudFeedReact        = (id) => apiFetch('/feed/react', { method: 'POST', body: JSON.stringify({ id }) });
export const cloudCollabAdd        = (deckId, name, subject, username) => apiFetch('/decks/collab/add', { method: 'POST', body: JSON.stringify({ deckId, name, subject, username }) });
export const cloudCollabList       = (deckId) => apiFetch('/decks/collab/list?id=' + encodeURIComponent(deckId));
export const cloudCollabPull       = () => apiFetch('/decks/collab/pull');
export const cloudCollabPush       = (deckId, cards) => apiFetch('/decks/collab/push', { method: 'POST', body: JSON.stringify({ deckId, cards }) });

export async function refreshSocial() {
  try {
    const s = await cloudSocial();
    state.social = { friends: s.friends || 0, published: s.published || 0, likesReceived: s.likesReceived || 0, downloads: s.downloads || 0, friendRequests: s.friendRequests || 0 };
  } catch { /* offline – Werte bleiben */ }
  updateFriendBadge();
}
export function updateFriendBadge() {
  const show = state.social.friendRequests > 0;
  ['#friends-dot', '#people-dot'].forEach((s) => { const d = $(s); if (d) d.classList.toggle('hidden', !show); });
}
/* Freunde liegen jetzt als Unter-Reiter in der Community */
export function openFriends() { state.comTab = 'people'; setView('community'); }
export let socialPollTimer = null;
export function startSocialPoll() {
  if (socialPollTimer) return;
  socialPollTimer = setInterval(async () => {
    if (hasSession()) { await refreshSocial(); }
  }, 60000);
}

/* ── Karten eines Kurses/Decks als schlanke {front,back,hint}-Liste (zum Teilen) ── */
export function cardsAsPayload(cards) {
  return cards.map((c) => {
    const o = { front: c.front?.text || '', back: c.back?.text || '', hint: c.hint || '' };
    if (c.front?.image) o.fImg = c.front.image;   // Bilder werden mitgeteilt
    if (c.back?.image) o.bImg = c.back.image;
    if (c.cloze) o.cloze = 1;                       // Lückentext-Typ mitteilen
    if (c.tags && c.tags.length) o.tags = c.tags;   // Schlagwörter mitteilen
    return o;
  }).filter((c) => c.front || c.back || c.fImg || c.bImg);
}

